import { useEffect } from "react";
import { useWebSocket } from "./WebSocketProvider";

const TopicSubscriber = ({ subTopic, onMessageReceived }) => {
    const { subscribe, unsubscribe } = useWebSocket();

    useEffect(() => {
        subscribe(subTopic, onMessageReceived);

        return () => {
            unsubscribe(subTopic, onMessageReceived);
        };
    }, [subTopic]);

    return null; // Non renderizza nulla
};

export default TopicSubscriber;